module.exports = __webpack_public_path__ + "static/media/progger3.836259a5.png";